module.exports = __webpack_public_path__ + "static/media/24-5.32d0e2f8.mp3";